export default __webpack_public_path__ + "static/media/rome.a69cd529.jpg";